"use client";

import {AiOutlineFileSearch} from "react-icons/ai";
import {SOSCard} from "./sosCard";

export const Resolved = ({
  sosCards,
  sosCardStatus,
  onStatusChange,
  filterData
}: any) => {
  return (
    <>
      <div className="grid grid-cols-4 gap-3 p-3 ">
        {filterData.map(
          (b: any) =>
            b.status === 2 && (
              <SOSCard
                key={b.id}
                b={b}
                currentTab="resolved"
                onStatusChange={onStatusChange}
                statusDetails={sosCardStatus(b.status)}
              />
            )
        )}
        {filterData.length === 0 && (
          <div className="col-span-full flex min-h-[260px] w-full flex-col items-center justify-center text-center">
            {/* Icon */}
            <div className="mb-4">
              <AiOutlineFileSearch size={48} className="" />
            </div>

            {/* Title */}
            <h2 className="text-lg font-semibold text-gray-800">
              No record found
            </h2>

            {/* Description */}
            <p className="mt-1 text-sm text-gray-500">
              Please adjust the name of your search.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
